import { Popover } from 'antd'
import { TooltipPlacement } from 'antd/lib/tooltip'
import { FC, ReactNode } from 'react'
import { Colors, FlexJustify } from '../../util/types'
import PerButtonCircle, { isProcessingCircleButton } from '../ButtonCircle'
import PerFlexRow from '../FlexRow'
import { icons } from '../Icon/icons'
import PerSpacer from '../Spacer'

type button = {
  icon?: keyof typeof icons
  iconVariant?: 'decoration' | 'clickable'
  size?: 'xsmall' | 'small' | 'large'
  color?: Colors
  variant?: 'bold' | 'pastel' | 'default'
  tooltip?: string
  onClick?: (value: unknown) => void
  asLink?: string
  showOnlyWhen?: boolean
  disabled?: boolean
  isProcessing?: isProcessingCircleButton
  popover?: {
    title: string | ReactNode
    content: ReactNode
    visible: boolean
    onVisibleChange: (value: boolean) => void
    width?: string
    placement?: TooltipPlacement
  }
  reactNode?: ReactNode
  additionalAttrs?: Record<string, string>
}

type Props = {
  buttons: button[]
  variant?: 'bold' | 'pastel'
  justify?: FlexJustify
  destroyTooltipOnHide?: boolean
}

export const PerTableActionButtons: FC<Props> = ({ buttons, variant = 'bold', justify = 'start', destroyTooltipOnHide = false }) => {
  const renderButtonOrButtonWithPopover = (button: button, i: number, isLast: boolean) => {
    const renderButton = () => {
      const mr = 'xxxs'
      return button.reactNode ? (
        <PerSpacer mr={isLast ? undefined : mr} key={i} {...button.additionalAttrs}>
          {button.reactNode}
        </PerSpacer>
      ) : (
        <PerButtonCircle
          key={i}
          icon={button.icon}
          iconVariant={button.iconVariant}
          variant={button.variant ? button.variant : variant}
          color={button.color}
          tooltip={button.tooltip}
          onClick={button.onClick}
          size={button.size}
          asLink={button.asLink}
          mr={isLast ? undefined : mr}
          disabled={button.disabled}
          {...button.additionalAttrs}
        />
      )
    }
    if (button.popover) {
      return (
        <Popover
          key={i}
          title={button.popover.title}
          content={button.popover.content}
          visible={button.popover.visible}
          onVisibleChange={button.popover.onVisibleChange}
          overlayStyle={{ width: button.popover.width === undefined ? '175px' : button.popover.width }}
          placement={button.popover.placement || 'bottom'}
          trigger="click"
          destroyTooltipOnHide={destroyTooltipOnHide}
        >
          {renderButton()}
        </Popover>
      )
    } else {
      return renderButton()
    }
  }

  const visibleButtons = buttons.filter((b) => (b.showOnlyWhen === undefined ? true : b.showOnlyWhen))
  return (
    <PerFlexRow justify={justify} align="middle" mx={justify !== 'start' ? 'm' : 'none'} noWrap={true}>
      {visibleButtons.map((button, i) => renderButtonOrButtonWithPopover(button, i, i === visibleButtons.length - 1))}
    </PerFlexRow>
  )
}
